import { useState, useEffect } from "react";
import Breadcrumb from "../../../layouts/full-layout/breadcrumb/Breadcrumb";
import {
  Card,
  CardContent,
  Box,
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  TableSortLabel,
  IconButton,
  TableContainer,
  Paper,
  Tabs,
  Tab,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import FeatherIcon from "feather-icons-react";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import CustomTextField from "../../../components/forms/custom-elements/CustomTextField";
import PageContainer from "../../../components/container/PageContainer";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import { useNavigate, useParams } from "react-router";
import { routes } from "../../../routes/routes";
import { GetEmployeeById } from "../../../services/admin";
import { toast } from "react-toastify";
import { GetUserDetail } from "../../../services/user";
import {
  ApproveEmployeeOfTheMonth,
  GetAllEmployeeOfTheMonthNominees,
} from "../../../services/human-resource";
import EmployeeOfMonthVoteModal from "./EmployeeOfMonthVoteModal";

const BCrumb = [
  {
    to: "/",
    title: "HR Management",
  },
  {
    title: "EOM Final Nominees",
  },
];

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  const loginUser = JSON.parse(localStorage.getItem("user"));
  const loggedInUserId = loginUser?.PersonId;

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const FinalNomineeList = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [orderDirection, setOrderDirection] = useState("asc");
  const [valueToOrderBy, setValueToOrderBy] = useState("");
  const [nomineeList, setNomineeList] = useState([]);
  const [totalLength, setTotalLength] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  const [employeeid, setEmployeeId] = useState();
  // Only this person can perform the EOM final approval.
  const FINAL_APPROVER_PERSON_ID = 7315;
  const [finalSubmitAllowed, setFinalSubmitAllowed] = useState(false);
  const [employeeTypeTab, setEmployeeTypeTab] = useState(0);
  const currentDate = new Date();

  const defaultMonth =
    currentDate.getMonth() === 0 ? 12 : currentDate.getMonth();

  const defaultYear =
    currentDate.getMonth() === 0
      ? currentDate.getFullYear() - 1
      : currentDate.getFullYear();

  const [selectedMonth, setSelectedMonth] = useState(defaultMonth);
  const [selectedYear, setSelectedYear] = useState(defaultYear);

  const currentYear = new Date().getFullYear();

  const years = Array.from({ length: 20 }, (_, index) => currentYear - index);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchValue]);

  useEffect(() => {
    if (employeeid) {
      getAllEmpOfTheMonthNomineesList();
    }
  }, [
    employeeid,
    debouncedSearchValue,
    valueToOrderBy,
    orderDirection,
    selectedMonth,
    selectedYear,
  ]);

  useEffect(() => {
    getUserDetail();
  }, []);

  const [openVoteModal, setOpenVoteModal] = useState(false);
  const [selectedNomineeId, setSelectedNomineeId] = useState(0);

  const handleOpenVoteModal = (id) => {
    setSelectedNomineeId(id);
    setOpenVoteModal(true);
  };

  const handleFinalApprove = async (nomineeId) => {
    try {
      const payload = {
        nomineeId,
        isApproved: true,
        remarks: "",
        approvalType: "FINAL",
        isVoid: false,
      };

      const response = await ApproveEmployeeOfTheMonth(payload);

      if (response?.status === 200) {
        toast.success("Employee of the Month finalized successfully.");

        await getAllEmpOfTheMonthNomineesList();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Unable to finalize Employee of the Month.",
      );
    }
  };

  const handleCloseVoteModal = () => {
    setOpenVoteModal(false);
    setSelectedNomineeId(0);
  };

  const getUserDetail = async () => {
    debugger;
    try {
      const response = await GetUserDetail();
      setEmployeeId(response?.data?.personId);
    } catch (e) {}
  };

  const getAllEmpOfTheMonthNomineesList = async () => {
    const searchKeyword = debouncedSearchValue ? debouncedSearchValue : null;

    const sortValue = `${valueToOrderBy} ${orderDirection}`;

    const data = {
      start: 0,
      length: 10000,
      sortExpression: sortValue,
      searchKeyword: searchKeyword,
      personId: employeeid ? parseInt(employeeid, 10) : null,
      moduleType: "FINAL",

      data: {
        month: selectedMonth,
        year: selectedYear,
      },
    };

    try {
      const response = await GetAllEmployeeOfTheMonthNominees(data);

      if (response?.status === 200) {
        setNomineeList(response?.data?.result);
        setTotalLength(response?.data?.totalRecords);
        // Backend may return false depending on the deployed SP, but PersonId 7315
        // must always be allowed to perform the final approval.
        setFinalSubmitAllowed(
          response?.data?.finalSubmitAllowed === true ||
            Number(employeeid) === FINAL_APPROVER_PERSON_ID,
        );
      }
    } catch (e) {}
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  //Sorting function call
  const handlRequestSort = (property) => {
    const isAscending = valueToOrderBy === property && orderDirection === "asc";
    setValueToOrderBy(property);
    setOrderDirection(isAscending ? "desc" : "asc");
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Office employees are returned as "Staff" in the current API.
  // Also support "Office Employee" for older/different API values.
  const isOfficeEmployee = (employee) => {
    const type = String(employee?.employeeType ?? "")
      .trim()
      .toLowerCase();

    return (
      type === "staff" ||
      type === "office employee" ||
      type === "office staff" ||
      type === "office"
    );
  };

  const officeEmployees = nomineeList?.filter(isOfficeEmployee);

  const otherEmployees = nomineeList?.filter(
    (employee) => !isOfficeEmployee(employee),
  );

  const filteredNomineeList =
    employeeTypeTab === 0 ? officeEmployees : otherEmployees;

  const isFinalApproved = (row) =>
    row?.finalApproval === true || row?.FinalApproval === true;

  // Winner first
  // const sortedNomineeList = [...filteredNomineeList].sort(
  //   (a, b) => Number(isFinalApproved(b)) - Number(isFinalApproved(a)),
  // );
  const sortedNomineeList = [...filteredNomineeList].sort((a, b) => {
    const aVotes = Number(a?.mpcVoteCount ?? 0);
    const bVotes = Number(b?.mpcVoteCount ?? 0);

    if (bVotes !== aVotes) {
      return bVotes - aVotes;
    }

    return Number(isFinalApproved(b)) - Number(isFinalApproved(a));
  });

  const officeFinalApproved = officeEmployees.some(isFinalApproved);

  const otherFinalApproved = otherEmployees.some(isFinalApproved);

  const currentTabFinalApproved =
    employeeTypeTab === 0 ? officeFinalApproved : otherFinalApproved;

  // Final approval button is visible only to the specified final approver.
  const isFinalApprover = Number(employeeid) === FINAL_APPROVER_PERSON_ID;

  const tabTotalLength = sortedNomineeList?.length || 0;

  const paginatedNomineeList =
    rowsPerPage === tabTotalLength
      ? sortedNomineeList
      : sortedNomineeList?.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage,
        );

  const winnerRowSx = {
    position: "relative",
    background:
      "linear-gradient(90deg, rgba(255, 193, 7, 0.12), rgba(255, 193, 7, 0.04))",
    animation: "winnerGlow 2s ease-in-out infinite",
    "@keyframes winnerGlow": {
      "0%, 100%": {
        boxShadow: "inset 4px 0 0 rgba(255, 193, 7, 0.7)",
      },
      "50%": {
        boxShadow: "inset 8px 0 0 rgba(255, 193, 7, 1)",
      },
    },
  };

  // const getMpcVotes = (row) => ({
  //   MPC1: row?.mpC1Vote,
  //   MPC2: row?.mpC2Vote,
  //   MPC3: row?.mpC3Vote,
  // });

  // const getPendingMpcVotes = (row) => {
  //   const votes = getMpcVotes(row);

  //   return Object.entries(votes)
  //     .filter(([, vote]) => vote === null || vote === undefined || vote === "")
  //     .map(([mpc]) => mpc);
  // };

  const selectMenuProps = {
    PaperProps: {
      sx: {
        maxHeight: 300,
        mt: 0.5,
      },
    },
  };

  return (
    <>
      <PageContainer>
        <Breadcrumb
          title="Employee Of The Month Final Nominees"
          items={BCrumb}
        />
        <Card
          sx={{
            p: 0,
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            gap={2}
            p={2}
            sx={{
              backgroundColor: "primary.light",
              color: "primary.main",
              flexWrap: "wrap",
            }}
          >
            <Box display="flex" alignItems="center">
              <FeatherIcon icon="alert-circle" width="18" />
              <Box sx={{ ml: 1 }}>Final Nominees</Box>
            </Box>

            <Box
              sx={{
                ml: "auto",
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              {/* Month */}
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Month</InputLabel>

                <Select
                  value={selectedMonth}
                  label="Month"
                  onChange={(e) => {
                    setSelectedMonth(Number(e.target.value));
                    setPage(0);
                  }}
                  MenuProps={selectMenuProps}
                >
                  {monthNames.map((month, index) => (
                    <MenuItem key={month} value={index + 1}>
                      {month}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Year */}
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Year</InputLabel>

                <Select
                  value={selectedYear}
                  label="Year"
                  onChange={(e) => {
                    setSelectedYear(Number(e.target.value));
                    setPage(0);
                  }}
                  MenuProps={selectMenuProps}
                >
                  {years.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Search */}
              <CustomTextField
                id="search"
                placeholder="Search Nominee..."
                size="small"
                type="search"
                variant="outlined"
                sx={{
                  width: 250,
                  backgroundColor: "white",
                  borderRadius: 1,
                }}
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  setPage(0);
                }}
              />
            </Box>
          </Box>

          {/* <CardContent>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              gap={2}
            > */}
          {/* <Button
                variant="contained"
                color="primary"
                onClick={() =>
                  navigate(routes?.EmployeeOfTheMonthNomination?.match)
                }
              >
                Add Nomination
              </Button> */}
          {/* </Box>
          </CardContent> */}
          <CardContent sx={{ pb: 0 }}>
            <Tabs
              value={employeeTypeTab}
              onChange={(event, newValue) => {
                setEmployeeTypeTab(newValue);
                setPage(0);
                setRowsPerPage(5);
              }}
              variant="fullWidth"
            >
              <Tab label="Office Employees" />
              <Tab label="Factory Staff" />
            </Tabs>
          </CardContent>
          <CardContent>
            <Grid item lg={12} md={12} sm={12}>
              <TableContainer
                component={Paper}
                sx={{ maxHeight: 450, overflowY: "auto", overflowX: "auto" }}
              >
                <Table
                  stickyHeader
                  aria-label="custom pagination table"
                  sx={{
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableHead sx={{ position: "sticky", top: 0, zIndex: 1 }}>
                    <TableRow>
                      <TableCell align="left">
                        <TableSortLabel
                          active={valueToOrderBy === "EmployeeName"}
                          direction={
                            valueToOrderBy === "EmployeeName"
                              ? orderDirection
                              : "desc"
                          }
                          onClick={() => handlRequestSort("EmployeeName")}
                        >
                          Employee Name
                        </TableSortLabel>
                      </TableCell>
                      <TableCell align="left">
                        <TableSortLabel
                          active={valueToOrderBy === "DepartmentName"}
                          direction={
                            valueToOrderBy === "DepartmentName"
                              ? orderDirection
                              : "desc"
                          }
                          onClick={() => handlRequestSort("DepartmentName")}
                        >
                          Department
                        </TableSortLabel>
                      </TableCell>
                      <TableCell align="left">
                        <TableSortLabel
                          active={valueToOrderBy === "Supervisor"}
                          direction={
                            valueToOrderBy === "Supervisor"
                              ? orderDirection
                              : "desc"
                          }
                          onClick={() => handlRequestSort("Supervisor")}
                        >
                          Supervisor
                        </TableSortLabel>
                      </TableCell>
                      <TableCell align="left">
                        <TableSortLabel
                          active={valueToOrderBy === "EmployeeType"}
                          direction={
                            valueToOrderBy === "EmployeeType"
                              ? orderDirection
                              : "desc"
                          }
                          onClick={() => handlRequestSort("EmployeeType")}
                        >
                          Employee Type
                        </TableSortLabel>
                      </TableCell>

                      <TableCell align="left">
                        <TableSortLabel
                          active={valueToOrderBy === "NominatedBy"}
                          direction={
                            valueToOrderBy === "NominatedBy"
                              ? orderDirection
                              : "desc"
                          }
                          onClick={() => handlRequestSort("NominatedBy")}
                        >
                          Nominated by
                        </TableSortLabel>
                      </TableCell>
                      <TableCell align="left">
                        <TableSortLabel
                          active={valueToOrderBy === "month"}
                          direction={
                            valueToOrderBy === "month" ? orderDirection : "desc"
                          }
                          onClick={() => handlRequestSort("month")}
                        >
                          Month
                        </TableSortLabel>
                      </TableCell>
                      {/* <TableCell align="left">
                        <TableSortLabel
                          active={valueToOrderBy === "NominatedDate"}
                          direction={
                            valueToOrderBy === "NominatedDate"
                              ? orderDirection
                              : "desc"
                          }
                          onClick={() => handlRequestSort("NominatedDate")}
                        >
                          Date
                        </TableSortLabel>
                      </TableCell> */}
                      <TableCell align="center">MPC Votes</TableCell>
                      <TableCell>
                        <TableSortLabel
                          active={valueToOrderBy === "Status"}
                          direction={
                            valueToOrderBy === "Status"
                              ? orderDirection
                              : "desc"
                          }
                          onClick={() => handlRequestSort("Status")}
                        >
                          Status
                        </TableSortLabel>
                      </TableCell>
                      <TableCell align="left">Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedNomineeList?.length > 0 ? (
                      paginatedNomineeList.map((rows) => {
                        const mpcVoteCount = Number(
                          rows?.mpcVoteCount ?? rows?.MPCVoteCount ?? 0,
                        );

                        const mpcMemberCount = Number(
                          rows?.mpcMemberCount ?? rows?.MPCMemberCount ?? 0,
                        );

                        const finalApproveDisabled =
                          currentTabFinalApproved ||
                          rows?.finalApproval === true;

                        const finalApproveTooltip = rows?.finalApproval
                          ? "This nominee is already finalized."
                          : currentTabFinalApproved
                          ? "A nominee has already been finalized for this employee type."
                          : "";

                        return (
                          <TableRow
                            key={rows?.id}
                            sx={{
                              position: "relative",
                              overflow: "hidden",

                              backgroundColor: rows?.finalApproval
                                ? "#e8f8e8"
                                : "inherit",

                              ...(rows?.finalApproval && {
                                // Keep the winner highlight static.
                                // Do not use a transformed ::after overlay here:
                                // table-row pseudo-elements can expand horizontal
                                // overflow while the animation is running.
                                boxShadow: "inset 4px 0 0 #2fdd4c",
                              }),

                              "&:hover": {
                                backgroundColor: rows?.finalApproval
                                  ? "#d9f3dc"
                                  : undefined,
                              },
                            }}
                          >
                            <TableCell>
                              {rows?.middleName
                                ? `${rows?.firstName} ${rows?.middleName} ${rows?.lastName}`
                                : `${rows?.firstName} ${rows?.lastName}`}
                            </TableCell>

                            <TableCell>{rows?.departmentName}</TableCell>
                            <TableCell>{rows?.supervisor}</TableCell>
                            <TableCell>{rows?.employeeType}</TableCell>
                            <TableCell>{rows?.nominatedBy}</TableCell>

                            <TableCell>
                              {monthNames[parseInt(rows?.month) - 1]}
                            </TableCell>

                            <TableCell align="center">
                              <strong>{mpcVoteCount}</strong> / {mpcMemberCount}
                            </TableCell>

                            <TableCell
                              sx={{
                                fontSize: rows?.finalApproval ? "18px" : "14px",
                                fontWeight: rows?.finalApproval ? 700 : 400,
                              }}
                            >
                              {rows?.finalApproval ? "🏆 Winner 🏆" : "Nominee"}
                            </TableCell>

                            <TableCell>
                              <IconButton
                                color="primary"
                                onClick={() => handleOpenVoteModal(rows.id)}
                              >
                                <PreviewIcon />
                              </IconButton>

                              {isFinalApprover && finalSubmitAllowed && (
                                <Tooltip
                                  title={
                                    finalApproveDisabled
                                      ? finalApproveTooltip
                                      : ""
                                  }
                                  arrow
                                >
                                  <span>
                                    <Button
                                      variant="contained"
                                      color={
                                        rows?.finalApproval
                                          ? "success"
                                          : "primary"
                                      }
                                      size="small"
                                      disabled={finalApproveDisabled}
                                      onClick={() =>
                                        handleFinalApprove(rows.id)
                                      }
                                      sx={{
                                        ml: 1,
                                        textTransform: "none",
                                        minWidth: 110,
                                      }}
                                    >
                                      {rows?.finalApproval
                                        ? "Final Approved"
                                        : "Final Approve"}
                                    </Button>
                                  </span>
                                </Tooltip>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={9}
                          align="center"
                          sx={{
                            py: 8,
                            color: "text.secondary",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Box
                              sx={{
                                fontSize: "16px",
                                fontWeight: 600,
                              }}
                            >
                              No nominees found
                            </Box>

                            <Box
                              sx={{
                                fontSize: "14px",
                                color: "text.secondary",
                              }}
                            >
                              No nominees are available for{" "}
                              {monthNames[selectedMonth - 1]} {selectedYear}.
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow></TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Grid>
            <Box style={{ display: "flex", justifyContent: "flex-end" }}>
              <TablePagination
                rowsPerPageOptions={[
                  5,
                  10,
                  25,
                  { label: "All", value: tabTotalLength },
                ]}
                colSpan={10}
                count={tabTotalLength}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputprops: {
                    "aria-label": "rows per page",
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Box>
          </CardContent>
        </Card>
      </PageContainer>
      <EmployeeOfMonthVoteModal
        open={openVoteModal}
        handleClose={handleCloseVoteModal}
        nomineeId={selectedNomineeId}
        canVote={false}
      />
    </>
  );
};

export default FinalNomineeList;
